<div class="container title-container">
    <div class="row">
        <div class="col-md-12 title-inner-container">
            <h2 id="partialQuoteHeader{{iterationId}}" class="text-number-style">
                {{contentData.partialQuotesHeader}}</h2>
            <span id="quoteRefNumber{{iterationId}}" class="Rectangle application-Reference">
                <i>{{cmsDataProductQuote.quoteReferenceNo}}</i>{{Partialproductquote.quoteRefNo}}</span>
        </div>
    </div>
</div>
<div class="row content-container">
    <div class="flex-vertical col-md-4">
        <span id="prodcutChoiceText{{iterationId}}" class="product-option">{{contentData.productChoiceInfo}}</span>
        <div *ngIf="Partialproductquote.selectedProduct === null || Partialproductquote.selectedProduct === '' ;else displayNotProvidedProductChoice"
            id="productChoice{{iterationId}}">
            <span id="productChoiceValue{{iterationId}}" class="income-style">{{contentData.notSelectedInfo}}</span>
        </div>
        <div>
            <ng-template id="productChoice" #displayNotProvidedProductChoice>
                <span id="selectedProductValue{{iterationId}}"
                    class="text-number-style">{{Partialproductquote.selectedProduct}}</span>
            </ng-template>
        </div>
    </div>
    <div class=" flex-vertical col-md-4">
        <span id="pensionPotText{{iterationId}}" class="product-option"
            [innerHTML]="Partialproductquote.selectedProductCode === 'C' ? contentData.annuityPensionPotInfo : contentData.pensionPotInfo">
        </span>
        <div *ngIf="+Partialproductquote.pensionFund > 0 ;else displayNotProvidedPensionFund"
            id="pensionFund{{iterationId}}" class="text-number-style">
            <span id="pensionPotCurrType{{iterationId}}" class="text-style-1">{{contentData.currencyType}}</span>
            <span id="pensionPotPensFundBeforeDot{{iterationId}}"
                class="number-style-2">{{getInteger(Partialproductquote.pensionFund)|
                currency:'':'':'1.0-0'}}{{contentData.currencyPoint}}</span>
            <span id="pensionPotPensFundAfterDot{{iterationId}}"
                class="text-style-1">{{getFraction(Partialproductquote.pensionFund)}}</span>
        </div>
        <div>
            <ng-template id="pensionFund" #displayNotProvidedPensionFund>
                <span id="pensionFundValue{{iterationId}}" class="income-style">{{contentData.notSelectedInfo}}</span>
            </ng-template>
        </div>
    </div>
    <div class=" flex-vertical col-md-4">
        <div *ngIf="Partialproductquote.quoteDateFlag === true ; else displayQuoteNotStarted"
            id="commencementDate{{iterationId}}">
            <span id="startDateText{{iterationId}}" class="product-option">{{contentData.estimatedStartDate}}</span>
        </div>
        <div>
            <ng-template id="productChoice" #displayQuoteNotStarted>
                <span id="startDateText{{iterationId}}"
                    class="product-option">{{contentData.startDateNotEntered}}</span>

            </ng-template>
            <span id="startDateValue{{iterationId}}"
                class="income-style">{{Partialproductquote.commencementDate}}</span>
        </div>
    </div>
</div>